import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Card,
  Row,
  Col,
  Table,
  Alert,
  Modal,
  InputGroup,
} from "react-bootstrap";

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [activeOption, setActiveOption] = useState("create");
  const [busqueda, setBusqueda] = useState("");
  const [usuarioAEliminar, setUsuarioAEliminar] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [formData, setFormData] = useState({
    Identificacion: "",
    Num_Identificacion: "",
    Nombre: "",
    Apellidos: "",
    DenominacionSocial: "",
    Email: "",
    Telefono: "",
    Direccion: "",
    Contraseña: "",
    Rol: "usuario",
  });

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/usuarios", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.ok) {
        const data = await response.json();
        setUsuarios(data);
      } else {
        throw new Error("Error al obtener los usuarios");
      }
    } catch (error) {
      console.error(error);
      setShowError(true);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://oficinavirtual-solponiente.com/api/usuarios", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setShowSuccess(true);
        fetchUsuarios();
        setFormData({
          Identificacion: "",
          Num_Identificacion: "",
          Nombre: "",
          Apellidos: "",
          DenominacionSocial: "",
          Email: "",
          Telefono: "",
          Direccion: "",
          Contraseña: "",
          Rol: "usuario",
        });
      } else {
        throw new Error("Error al crear el usuario");
      }
    } catch (error) {
      console.error(error);
      setShowError(true);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/usuarios/${selectedUsuario.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(formData),
        }
      );
      if (response.ok) {
        fetchUsuarios();
        setShowSuccess(true);
        setSelectedUsuario(null);
      } else {
        throw new Error("Error al actualizar el usuario");
      }
    } catch (error) {
      console.error(error);
      setShowError(true);
    }
  };

  const handleEdit = (usuario) => {
    setSelectedUsuario(usuario);
    setFormData(usuario);
  };

  const confirmarEliminar = (usuario) => {
    setUsuarioAEliminar(usuario);
    setShowConfirmDelete(true);
  };

  const cancelarEliminar = () => {
    setUsuarioAEliminar(null);
    setShowConfirmDelete(false);
  };

  const handleDelete = async () => {
    if (!usuarioAEliminar) return;
    try {
      const response = await fetch(
        `https://oficinavirtual-solponiente.com/api/usuarios/${usuarioAEliminar.id}`,
        {
          method: "DELETE",
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      if (response.ok) {
        fetchUsuarios();
        setShowSuccess(true);
      } else {
        throw new Error("Error al eliminar el usuario");
      }
    } catch (error) {
      console.error(error);
      setShowError(true);
    } finally {
      setShowConfirmDelete(false);
      setUsuarioAEliminar(null);
    }
  };

  const renderFormFields = () => (
    <>
      {/* Sección: Identificación */}
      <div className="mb-4">
        <p className="text-uppercase fw-semibold small text-muted border-bottom pb-1 mb-3">
          <i className="bi bi-person-badge me-2 text-primary"></i>Identificación
        </p>
        <Row>
          <Col md={5}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Tipo</Form.Label>
              <Form.Select
                name="Identificacion"
                value={formData.Identificacion}
                onChange={handleChange}
                required
              >
                <option value="">Seleccione...</option>
                <option value="DNI">DNI</option>
                <option value="NIE">NIE</option>
                <option value="CIF">CIF</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={7}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Número</Form.Label>
              <Form.Control
                type="text"
                name="Num_Identificacion"
                value={formData.Num_Identificacion}
                onChange={handleChange}
                placeholder="Ej: 12345678A"
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* Sección: Datos personales */}
      <div className="mb-4">
        <p className="text-uppercase fw-semibold small text-muted border-bottom pb-1 mb-3">
          <i className="bi bi-person me-2 text-primary"></i>Datos personales
        </p>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Nombre</Form.Label>
              <Form.Control
                type="text"
                name="Nombre"
                value={formData.Nombre}
                onChange={handleChange}
                placeholder="Nombre"
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Apellidos</Form.Label>
              <Form.Control
                type="text"
                name="Apellidos"
                value={formData.Apellidos}
                onChange={handleChange}
                placeholder="Apellidos"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3">
          <Form.Label className="small fw-semibold">Denominación Social</Form.Label>
          <Form.Control
            type="text"
            name="DenominacionSocial"
            value={formData.DenominacionSocial}
            onChange={handleChange}
            placeholder="Empresa o entidad (si aplica)"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className="small fw-semibold">Dirección</Form.Label>
          <Form.Control
            type="text"
            name="Direccion"
            value={formData.Direccion}
            onChange={handleChange}
            placeholder="Calle, número, localidad"
            required
          />
        </Form.Group>
      </div>

      {/* Sección: Contacto */}
      <div className="mb-4">
        <p className="text-uppercase fw-semibold small text-muted border-bottom pb-1 mb-3">
          <i className="bi bi-envelope me-2 text-primary"></i>Contacto
        </p>
        <Row>
          <Col md={7}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Email</Form.Label>
              <Form.Control
                type="email"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                placeholder="correo@ejemplo.com"
                required
              />
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Teléfono</Form.Label>
              <Form.Control
                type="text"
                name="Telefono"
                value={formData.Telefono}
                onChange={handleChange}
                placeholder="Ej: 600 000 000"
                required
              />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* Sección: Acceso */}
      <div className="mb-3">
        <p className="text-uppercase fw-semibold small text-muted border-bottom pb-1 mb-3">
          <i className="bi bi-shield-lock me-2 text-primary"></i>Acceso
        </p>
        <Row>
          <Col md={7}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Contraseña</Form.Label>
              <Form.Control
                type="password"
                name="Contraseña"
                value={formData.Contraseña}
                onChange={handleChange}
                placeholder="Contraseña"
                required
              />
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">Rol</Form.Label>
              <Form.Select
                name="Rol"
                value={formData.Rol}
                onChange={handleChange}
                required
              >
                <option value="usuario">Usuario</option>
                <option value="admin">Administrador</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <div>
      <Row>
        <Col md={12} className="mx-auto">

          {/* Toggle Crear / Editar */}
          <Card className="shadow-sm mb-4 border-0" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title>
                <i className="bi bi-people me-2 text-primary"></i>
                <strong>Gestión de Usuarios</strong>
              </Card.Title>
              <p className="text-muted mb-3">Seleccione una opción para continuar:</p>
              <Row>
                <Col>
                  <Button
                    variant={activeOption === "create" ? "primary" : "outline-primary"}
                    onClick={() => setActiveOption("create")}
                    className="w-100"
                  >
                    <i className="bi bi-person-plus me-2"></i>Crear Usuario
                  </Button>
                </Col>
                <Col>
                  <Button
                    variant={activeOption === "edit" ? "primary" : "outline-primary"}
                    onClick={() => setActiveOption("edit")}
                    className="w-100"
                  >
                    <i className="bi bi-pencil me-2"></i>Editar / Eliminar
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Alertas globales */}
          {showSuccess && (
            <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
              <i className="bi bi-check-circle me-2"></i>Operación realizada con éxito.
            </Alert>
          )}
          {showError && (
            <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
              <i className="bi bi-exclamation-triangle me-2"></i>Ocurrió un error al procesar la solicitud.
            </Alert>
          )}

          {/* Crear usuario */}
          {activeOption === "create" && (
            <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
              <Card.Body className="p-4">
                <Card.Title className="mb-4">
                  <i className="bi bi-person-plus me-2 text-primary"></i>
                  <strong>Nuevo Usuario</strong>
                </Card.Title>
                <Form onSubmit={handleCreateSubmit}>
                  {renderFormFields()}
                  <div className="mt-3">
                    <Button variant="primary" type="submit" >
                      <i className="bi bi-check-lg me-2"></i>Crear
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}

          {/* Editar / Eliminar */}
          {activeOption === "edit" && (
            <Card className="shadow-sm border-0" style={{ borderRadius: "0.75rem" }}>
              <Card.Body className="p-4">
                <Card.Title className="mb-3">
                  <i className="bi bi-pencil me-2 text-primary"></i>
                  <strong>Editar / Eliminar Usuario</strong>
                </Card.Title>

                {usuarios.length === 0 ? (
                  <Alert variant="warning">
                    No hay usuarios disponibles.
                  </Alert>
                ) : (
                  <>
                    <InputGroup className="mb-3" style={{ maxWidth: 450 }}>
                      <InputGroup.Text><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control
                        placeholder="Buscar por nombre, apellidos o DNI/NIE/CIF…"
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                      />
                      {busqueda && (
                        <Button variant="outline-secondary" onClick={() => setBusqueda("")}>✕</Button>
                      )}
                    </InputGroup>

                    <Table hover responsive className="align-middle mb-4">
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Apellidos</th>
                          <th>DNI/NIE/CIF</th>
                          <th>Email</th>
                          <th className="text-center">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usuarios
                          .filter((usuario) => {
                            const term = busqueda.toLowerCase();
                            if (!term) return true;
                            return (
                              usuario.Nombre?.toLowerCase().includes(term) ||
                              usuario.Apellidos?.toLowerCase().includes(term) ||
                              usuario.Num_Identificacion?.toLowerCase().includes(term)
                            );
                          })
                          .map((usuario) => (
                          <tr
                            key={usuario.id}
                            className={selectedUsuario?.id === usuario.id ? "table-primary" : ""}
                          >
                            <td>{usuario.Nombre}</td>
                            <td>{usuario.Apellidos}</td>
                            <td>{usuario.Num_Identificacion || "—"}</td>
                            <td>{usuario.Email}</td>
                            <td className="text-center">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEdit(usuario)}
                                className="me-2"
                              >
                                <i className="bi bi-pencil"></i>
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => confirmarEliminar(usuario)}
                              >
                                <i className="bi bi-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>

                    {selectedUsuario && (
                      <>
                        <p className="text-uppercase fw-semibold small text-muted border-bottom pb-1 mb-4">
                          Editando: {selectedUsuario.Nombre} {selectedUsuario.Apellidos}
                        </p>
                        <Form onSubmit={handleEditSubmit}>
                          {renderFormFields()}
                          <div className="mt-3">
                            <Button variant="primary" type="submit">
                              <i className="bi bi-check-lg me-2"></i>Guardar Cambios
                            </Button>
                          </div>
                        </Form>
                      </>
                    )}
                  </>
                )}
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>

      <Modal show={showConfirmDelete} onHide={cancelarEliminar} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar al usuario{" "}
          <strong>{usuarioAEliminar?.Nombre} {usuarioAEliminar?.Apellidos}</strong>?
          Esta acción no se puede deshacer.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelarEliminar}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Usuarios;